import { EDropdownMenuFilter } from 'src/components/MapSidebar/components/MapSidebarCommunitiesList/MapSidebarCommunitiesList.types';

export const DropdownMenuFilterLabels: Record<EDropdownMenuFilter, string> = {
  [EDropdownMenuFilter.Simulations]: 'Simulation',
  [EDropdownMenuFilter.CanaryNetworks]: 'Canary Network',
  [EDropdownMenuFilter.Collaborations]: 'Collaboration',
};
